var _circle, _circle2, _circle3, _circle4, _circle5, _path, _circle6, _circle7, _circle8, _circle9, _circle10, _path2, _circle11, _path3, _path4, _path5, _path6, _path7, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _path8, _path9, _path10, _rect, _rect2, _circle19, _path11, _g, _path12, _path13, _path14, _path15, _ellipse, _ellipse2, _path16, _path17, _path18, _path19, _ellipse3, _ellipse4, _path20, _path21, _path22, _path23, _ellipse5, _ellipse6, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse7, _path30, _ellipse8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEncumbrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 221,
    viewBox: "0 0 414 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.33,
    cy: 38.17,
    r: 19.09,
    fill: "#F4F5F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.42,
    cy: 19.09,
    r: 19.09,
    fill: "#F4F5F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.98,
    cy: 38.17,
    r: 19.09,
    fill: "#F4F5F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.81,
    cy: 22.41,
    r: 19.09,
    fill: "#F4F5F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.35,
    cy: 38.17,
    r: 19.09,
    fill: "#F4F5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F6",
    d: "M103.33 31.12h56.43v26.14h-56.43z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 35.59,
    r: 35.59,
    transform: "matrix(-1 0 0 1 357.49 68.7)",
    fill: "#F4F5F6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 35.59,
    r: 35.59,
    transform: "matrix(-1 0 0 1 321.9 33.12)",
    fill: "#F4F5F6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 35.59,
    r: 35.59,
    transform: "matrix(-1 0 0 1 313.4 68.7)",
    fill: "#F4F5F6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 35.59,
    r: 35.59,
    transform: "matrix(-1 0 0 1 270.85 39.31)",
    fill: "#F4F5F6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.59,
    cy: 35.59,
    r: 35.59,
    transform: "matrix(-1 0 0 1 253.05 68.7)",
    fill: "#F4F5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F6",
    d: "M321.9 91.14H216.7v48.74h105.2z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.47,
    cy: 72.15,
    r: 51.34,
    fill: "#E2E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.37 53.19v16.8m0 77.02V99.04M331.9 60.2l8.45 9.79m0 0v14.52m0 14.52-13.31-13.28m13.31 13.28V84.52m0 0 13.53-15.45",
    stroke: "#CBD5E1",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.58 129.08c0 15.81-12.8 34.72-28.6 34.72-15.78 0-28.59-18.9-28.59-34.72 0-15.8 8.76-53.97 28.6-53.97 19.84 0 28.6 38.17 28.6 53.97Z",
    fill: "#F4F5F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.94 109.57v20.77m0 51.76v-37.09m-9.25-25.08 9.25 10.4m0 0v14.68m0 0 10.03-11.96",
    stroke: "#E4EAEE",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.36 161.36c0 17.52-18.08 15.63-40.21 15.63-22.14 0-39.95 1.89-39.95-15.63 0-17.51 17.95-31.71 40.08-31.71s40.08 14.2 40.08 31.71Z",
    fill: "#F4F5F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.85 142.33v14.04m0 24.25v-15.2m9.3-17.67-9.3 8.62m0 0v9.05m0 0-10.03-7.33",
    stroke: "#EAEEF1",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.29,
    cy: 76.96,
    r: 26.36,
    fill: "#E2E8F0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.23,
    cy: 50.56,
    r: 21.88,
    fill: "#E2E8F0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.29,
    cy: 132.47,
    r: 21.88,
    fill: "#E2E8F0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.76,
    cy: 109.86,
    r: 21.88,
    fill: "#E2E8F0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.05,
    cy: 78.36,
    r: 24.96,
    fill: "#E2E8F0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.13,
    cy: 109.86,
    r: 24.96,
    fill: "#E2E8F0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.23,
    cy: 129.39,
    r: 24.96,
    fill: "#E2E8F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.89 76.99v27.91m0 69.57v-49.85m12.43-33.7L55.9 104.9m0 0v19.72m0 0-13.5-16.08",
    stroke: "#CBD5E1",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 163.43c0 13-14.11 11.6-31.39 11.6-17.27 0-31.17 1.4-31.17-11.6 0-13.01 14-23.56 31.28-23.56 17.27 0 31.27 10.55 31.27 23.56Z",
    fill: "#F4F5F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 150.7v9.03m0 15.6v-9.78m-8-11.36 8 5.54m0 0v5.82m0 0 8.63-4.71",
    stroke: "#EAEEF1",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 365.7,
    y: 43.83,
    width: 5.91,
    height: 151.07,
    rx: 2.95,
    fill: "#A1B6CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 353.88,
    y: 57.75,
    width: 29.43,
    height: 54.67,
    rx: 7.51,
    fill: "#566780"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.6,
    cy: 70.61,
    r: 5.97,
    fill: "#EA580C"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.6,
    cy: 85.08,
    rx: 5.97,
    ry: 5.91,
    fill: "#FACC15",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.6,
    cy: 99.55,
    r: 5.97,
    fill: "#54B659",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 105,
    width: 408,
    height: 116
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.3 220.51c-100.3 0-208.7-9.69-208.7-49.95 0-41.54 105.23-65.53 208.7-65.53 100.14 0 197.73 25.33 197.73 65.53 0 38.88-100.87 49.95-197.72 49.95Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54B659",
    d: "M-46.15 171.39h508.01v132.97H-46.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2 171.39h296l112.22 132.97H-47.07L54.2 171.4Z",
    fill: "#2C6CBA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    d: "M202.32 171.39h10.71v13.3h-10.71zm0 30.78h10.71v31.64h-10.71z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42 160.6c0 .04.75 2.2.06 4.98-.71 2.87-1.73 3.85-1.72 4.62l3.17-.04 3.26-.05",
    stroke: "#FF9800",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.23 159.22c-.02.02-1.15 2-3.7 3.32-2.64 1.36-4.05 1.24-4.62 1.76l2.1 2.34 2.17 2.42",
    stroke: "#F97316",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 149.8c0 7.32-5.93 13.25-13.24 13.25-7.31 0-16.44-5.93-16.44-13.24 0-7.31 9.13-13.25 16.44-13.25 7.31 0 13.24 5.94 13.24 13.25Z",
    fill: "#FACC15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.95 135.84c.46-.74 1.4-1.56 2.15-1.1 0 0 2.05 1.1 3.64 1.1 1.59 0 1.84-.1 2.92-.45 1.08-.34 1.76-.33 2.17.27.4.61-.15 1.46-.93 2.13-.78.68-2.82 1.56-5.34 1.56s-4.08-1.34-4.08-1.34a1.57 1.57 0 0 1-.53-2.17Z",
    fill: "#F97316"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.39,
    cy: 135.99,
    rx: 7.18,
    ry: 7.15,
    fill: "#FACC15"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.72,
    cy: 134.57,
    rx: 0.85,
    ry: 0.88,
    fill: "#204F88"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.56 161.4c.02.02 2.13.9 3.75 3.27 1.66 2.44 1.71 3.86 2.29 4.36l2.08-2.38 2.14-2.46",
    stroke: "#FF9800",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.4 160.61c0 .03.73 2.2 0 4.98-.75 2.87-1.77 3.84-1.77 4.6h6.39",
    stroke: "#F97316",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 149.5c0 7.31-5.93 13.24-13.24 13.24-7.32 0-16.39-5.93-16.39-13.24 0-7.31 9.07-13.24 16.39-13.24 7.31 0 13.24 5.93 13.24 13.24Z",
    fill: "#FACC15"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.97 135.53c.46-.74 1.4-1.56 2.15-1.1 0 0 2.06 1.1 3.64 1.1 1.59 0 1.84-.1 2.92-.45 1.08-.34 1.76-.33 2.17.27.4.61-.15 1.46-.93 2.13-.78.68-2.82 1.56-5.34 1.56s-4.08-1.34-4.08-1.34a1.58 1.58 0 0 1-.53-2.17Z",
    fill: "#F97316"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.41,
    cy: 135.68,
    rx: 7.18,
    ry: 7.15,
    fill: "#FACC15"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.74,
    cy: 134.26,
    rx: 0.85,
    ry: 0.88,
    fill: "#204F88"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.86 160.6c0 .04.75 2.2.06 4.98-.7 2.87-1.73 3.85-1.72 4.62l3.17-.04 3.26-.05",
    stroke: "#FF9800",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M189.68 159.22c-.03.02-1.16 2-3.71 3.32-2.64 1.36-4.04 1.24-4.62 1.76l2.1 2.34 2.17 2.42",
    stroke: "#F97316",
    strokeWidth: 2.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M203.93 149.8c0 7.32-5.93 13.25-13.25 13.25-7.31 0-17.26-5.93-17.26-13.24 0-7.32 9.95-13.25 17.26-13.25 7.32 0 13.25 5.93 13.25 13.25Z",
    fill: "#FACC15"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205.4 135.84c.45-.74 1.4-1.56 2.14-1.1 0 0 2.05 1.1 3.64 1.1 1.59 0 1.84-.1 2.92-.45 1.08-.34 1.76-.33 2.17.27.4.61-.15 1.46-.93 2.13-.78.68-2.83 1.56-5.34 1.56-2.52 0-4.08-1.34-4.08-1.34a1.58 1.58 0 0 1-.53-2.17Z",
    fill: "#F97316"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.82,
    cy: 135.99,
    rx: 7.18,
    ry: 7.15,
    fill: "#FACC15"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.16,
    cy: 134.57,
    rx: 0.85,
    ry: 0.88,
    fill: "#204F88"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M261.92 154.64c.03.04 3.62 1.52 6.37 5.56 2.83 4.16 2.92 6.57 3.9 7.43l3.54-4.06 3.65-4.18",
    stroke: "#FF9800",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M259.92 153.36c0 .05 1.24 3.73 0 8.46-1.28 4.86-3.03 6.51-3.03 7.82h10.93",
    stroke: "#F97316",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.36 129.14c0 14.1-13.5 25.53-30.16 25.53s-30.16-11.43-30.16-25.53c0-14.1 13.5-18.28 30.16-18.28s30.16 4.17 30.16 18.28Z",
    fill: "#FACC15"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M241.9 113.85c3.16 2.14 3.3 7.45.3 11.86-3 4.4-7.98 6.24-11.13 4.1-3.16-2.15-6.78-9.83-3.79-14.24 3-4.4 11.48-3.86 14.63-1.72Z",
    fill: "#FACC15"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M276.1 127.85c0 8.45-8.6 15.3-19.18 15.3-10.6 0-22.85-6.85-22.85-15.3 0-8.46 12.26-10.96 22.85-10.96 10.59 0 19.17 2.5 19.17 10.96Z",
    fill: "#EAB308"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M297.84 94.74c.64-1.05 1.97-2.21 3.03-1.57 0 0 2.9 1.57 5.14 1.57 2.24 0 2.6-.15 4.12-.63 1.52-.49 2.49-.48 3.06.38.58.86-.21 2.05-1.31 3-1.1.96-3.99 2.2-7.54 2.2-3.56 0-5.76-1.88-5.76-1.88a2.22 2.22 0 0 1-.74-3.07Z",
    fill: "#F97316"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.8,
    cy: 94.94,
    rx: 10.13,
    ry: 10.09,
    fill: "#FACC15"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M281.86 106.93c1.65-2.6 1.06-8.61.81-11.39l12.92 9.11c-1.42.26-5.34 2.12-7.04 6.23-1.57 3.77-.59 7.5.7 9.88-7.4-3.25-21.27-9.38-17.28-9.18 4.98.25 7.82-1.41 9.89-4.65Z",
    fill: "#FACC15"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.51,
    cy: 92.95,
    rx: 1.2,
    ry: 1.24,
    fill: "#204F88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncumbrance);
export default __webpack_public_path__ + "static/media/encumbrance.43184bf3fd74de388996f9ae8bde1a46.svg";
export { ForwardRef as ReactComponent };